import { gql } from '@apollo/client';

const observationReportReviewPageNotificationFragment = gql`
  fragment ObservationReportReviewPageNotificationFields on ObservationReportReviewPageNotification {
    ObservationReportId
    ObservedUser {
      FullName
    }
  }
`;

export default observationReportReviewPageNotificationFragment;
